import React from "react";

import AbhyaHasta from "../assets/Abhya Hasta.png";
import AduriInfra from "../assets/Aduri Infra.png";
import Arowwai from "../assets/Arowwai.png";
import Chiropractic from "../assets/Chiropractic.png";
import DayaInteriors from "../assets/Daya Interiors.png";
import GaneshTraders from "../assets/Ganesh Traders.png";
import HouseHunter from "../assets/HouseHunter.png";
import Larana from "../assets/Larana Online School.png";
import MukthaPhotography from "../assets/Muktha Photography.png";
import OOTD from "../assets/OOTD.png";
import OrganicFresh from "../assets/Organic fresh.png";
import ReativeStudio from "../assets/Reative Studio.png";
import SalfordCo from "../assets/Salford & co.png";
import SpineReset from "../assets/Spine Reset Chiropractic.png";
import StyleBliss from "../assets/stylebliss.png";
import VivInfra from "../assets/Viv Infra.png";

const OurClients = () => {
  const clients = [
    AbhyaHasta,
    VivInfra,
    OOTD,
    HouseHunter,
    DayaInteriors,
    Larana,
    GaneshTraders,
    SpineReset,
    OrganicFresh,
    ReativeStudio,
    SalfordCo,
    StyleBliss,
    AduriInfra,
    Chiropractic,
    MukthaPhotography,
    Arowwai,
  ];

  return (
    <section className="w-full bg-dark pt-10 pb-20 px-4 md:px-14">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
          Our <span className="bg-gradient-to-r from-orange-400 via-orange-400 to-orange-400 bg-clip-text text-transparent animate-gradient">Clients</span>
        </h2>
        <p className="text-gray-300 text-sm md:text-lg mt-3">
          Trusted by industry leaders and innovative companies worldwide
        </p>
      </div>

      {/* SCROLLING SECTION */}
      <div className="overflow-hidden w-full">
        <div className="flex gap-4 items-center scroll-track w-max">
          {clients.map((logo, i) => (
            <div
              key={`logo1-${i}`}
              className="bg-white rounded-xl shadow-lg p-6 
               w-48 h-32 sm:w-56 sm:h-36 md:w-64 md:h-40 lg:w-72 lg:h-44
               flex items-center justify-center 
               hover:scale-105 hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={logo}
                alt=""
                className="object-contain max-h-20 md:max-h-24 lg:max-h-28"
              />
            </div>
          ))}

          {clients.map((logo, i) => (
            <div
              key={`logo2-${i}`}
              className="bg-white rounded-xl shadow-lg p-6 
               w-48 h-32 sm:w-56 sm:h-36 md:w-64 md:h-40 lg:w-72 lg:h-44
               flex items-center justify-center 
               hover:scale-105 hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={logo}
                alt=""
                className="object-contain max-h-20 md:max-h-24 lg:max-h-28"
              />
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default OurClients;
